import { Chip, Content, Flex, usePlatformInfo } from '@acsbe/ui';
import { styled } from 'styled-components';

const LimitedAccessBanner = () => {
  const { uptoTablet } = usePlatformInfo();
  return (
    <BorderFlex
      row={!uptoTablet}
      align="flex-start"
      self="stretch"
      radius="lg"
      scale="base"
      border={0.25}
      gap={3}
      paddingBlock={3}
      paddingInline={4}
    >
      <Chip scale="warning">{'Widget management'}</Chip>
      <Content lineHeight={1.5}>
        {'Limited access mode lets you customize accessWidget’s appearance.'}
      </Content>
    </BorderFlex>
  );
};

const BorderFlex = styled(Flex)`
  --stroke: #cbd2e1;
`;

export { LimitedAccessBanner };
